import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import {ISettings} from "@/model/ISettings";
import responseHandler from "@/plugins/errorHandling";

export interface ITimeslotRestriction {
  id: number;
  foreign_id: number;
  target: number;
  type: number;
  weekday: number;
  data: string;
  created_at: string;
}
export interface IHoliday extends ITimeslotRestriction {}

interface SettingsState {
  holidays: IHoliday[];
  errors: IErrors;
  landingPages: ISettings[];
}

const state: SettingsState = {
  holidays: [],
  errors: {},
  landingPages: [],
};

const getters: GetterTree<SettingsState, RootState> = {
  holidays: (state): IHoliday[] => state.holidays,
  errors: (state) => state.errors,
  landingPages: (state) => state.landingPages
};

const actions: ActionTree<SettingsState, RootState> = {
  fetchHolidays: ({ commit }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'settings/holidays',
    }),
    commit,
    'holidaysLoaded'
  ),
  createHoliday: ({ commit }, {date}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'settings/holidays',
      method: 'POST',
      data: {
        date: date,
      }
    }),
    commit,
    'holidaysLoaded'
  ),
  deleteHoliday: ({ commit }, {date}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'settings/holidays/' + date,
      method: 'DELETE',
    }),
    commit,
    'holidaysLoaded',
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },
  fetchLandingPages: ({ commit }, filters): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'landingpages',
      params: filters
    }),
    commit,
    'landingPagesLoaded'
  ),
  clearLandingPages:  ({commit}): any => {
    commit('clearLandingPages');
  },
  createLandingPage: ({ commit }, data): any => responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'landingpages',
        method: 'POST',
        data,
      }),
      commit,
      'landingPageCreated'
  ),
  deleteLandingPage: ({commit}, id: number):any => responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'landingpages/' + id,
        method: 'DELETE',
      }),
      commit,
      'landingPageDeleted'
  ),
  resetErrors: ({commit}, index: any): any => {
    commit('resetErrors', index);
  },
};

const mutations: MutationTree<SettingsState> = {
  holidaysLoaded(state, payload) {
    state.holidays = payload;
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
  landingPagesLoaded(state, payload) {
    state.landingPages = state.landingPages.concat(payload);
  },
  clearLandingPages(state){
    state.landingPages = []
  },
  landingPageCreated(state, payload: ISettings){
    state.landingPages.push(payload)
  },
  landingPageDeleted(state, payload: ISettings) {
    state.landingPages = state.landingPages.filter(item => item.id !== payload.id);
  },
  resetErrors(state) {
    state.errors = {};
  },
};

const namespaced: boolean = true;

export const settingsModule: Module<SettingsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
